/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import isNil from 'lodash/isNil';

import { withTrailingSlash } from 'services/Externals';
import { GLOBALS } from 'services/globals';
import { brokerageFrameEnabled } from "./FeatureFlags";

export const VENDORS = {
  BROKERAGE: 'PERSHING',
  EDUCATION_PLANNING_CENTER_UA: 'EDUCATION_PLANNING_CENTER_UA',
  EDUCATION_PLANNING_CENTER: 'EDUCATION_PLANNING_CENTER',
  WALL_STREET_JOURNAL: 'WALL_STREET_JOURNAL',
  MONEY_GUIDE_PRO: 'MONEYGUIDPRO'
};

export const TRADING_IFRAME_TARGETS = [
  'TRADING',
  'MF_TRADING',
  'OPT_TRADING',
  'ORDERSTATUS'
]

const appContext = !isNil(GLOBALS.AAM_UI_TRP_APP_CONTEXT)
  ? GLOBALS.AAM_UI_TRP_APP_CONTEXT
  : '';
const appContextPath = withTrailingSlash(appContext);
const externalAuthorizationPath = `${appContextPath}external-authorization`;
export const externalAuthorizationTracPath = `${appContextPath}smallbusiness-external-authorization`;
const brokerageTradingPath = `${appContextPath}brokerage`;
export const openBrokerageAuthTab = (
  selectedAccountId,
  brokerageTarget = 'ACCOUNTSNAPSHOT'
) => {
  const externalAuthorizationURL = buildExternalAuthorizationUrl(
    VENDORS.BROKERAGE,
    selectedAccountId,
    brokerageTarget
  );
  if (brokerageFrameEnabled() && TRADING_IFRAME_TARGETS.some(it => it === brokerageTarget)) {
    open(externalAuthorizationURL, '_self');
  } else {
    open(externalAuthorizationURL);
  }
};

export const openEducationAuthTab = (isAlaska529) => {
  const vendor = isAlaska529
    ? VENDORS.EDUCATION_PLANNING_CENTER_UA
    : VENDORS.EDUCATION_PLANNING_CENTER;

  const externalAuthorizationURL = buildExternalAuthorizationUrl(vendor);
  open(externalAuthorizationURL);
};

export const openWSJAuthTab = () => {
  const externalAuthorizationURL = buildExternalAuthorizationUrl(
    VENDORS.WALL_STREET_JOURNAL
  );
  open(externalAuthorizationURL);
};

const buildExternalAuthorizationUrl = (vendor, selectedAccountId, target) => {
  let url = `${externalAuthorizationPath}?vendor=${vendor}`;
  if (vendor === VENDORS.BROKERAGE) {
    if (brokerageFrameEnabled() && TRADING_IFRAME_TARGETS.some(it => it === target)) {
      url = `${brokerageTradingPath}?action=trade`;
    }
    if (selectedAccountId) {
      url += `&selectedAccountId=${selectedAccountId}`;
    }
  }
  if (target) {
    url += `&target=${target}`;
  }
  return url;
};

export const openTracAuthTab = () => {
  open(externalAuthorizationTracPath);
};